import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InviteResolver } from './invite.resolver';
import { SignupByInviteGuard } from './signup-by-invite.guard';
import { SignupByInviteComponent } from './signup-by-invite.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'signup',
        canActivate: [SignupByInviteGuard],
        resolve: { invite: InviteResolver },
        component: SignupByInviteComponent,
      },
      {
        path: 'not-found',
        component: NotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SignupByInviteRoutingModule {}
